import i18n from "i18next";
import "../i18n";
import apiClient from "../api/client";
import { verificationConfirmErrorCopy } from "../helpers/verificationConfirmError";

// eslint-disable-next-line import/no-cycle
import { main, auth, account } from "../constants/actionTypes";
// eslint-disable-next-line import/no-cycle
import { actions as profileActions } from "./account/profile";

export const actions = {
  getCountriesAndStates() {
    return (dispatch, getState) => {
      const {
        main: { countries, states }
      } = getState();

      // Don't early-return on `preloaders.utilityListing` alone.
      // That flag is also toggled by the dashboard bootstrap loader, and can remain `true`
      // when the bootstrap response returns `reference_unchanged` (no countries/states),
      // which would otherwise block this fetch forever and leave location selects empty.
      if (countries?.length && states && Object.keys(states).length) {
        return Promise.resolve();
      }

      dispatch(this.setLoading("utilityListing", true));
      apiClient({
        method: "get",
        responseType: "json",
        url: "/members/json-api/index/countries-states",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      })
        .then(countriesStates => {
          dispatch({
            type: main.GET_UTILITY_LISTING,
            payload: {
              countries: countriesStates.data.countries,
              states: countriesStates.data.states
            }
          });
        })
        .catch(error => {
          dispatch({
            type: main.GET_UTILITY_LISTING_FAIL,
            payload: error
          });
          console.error("getMainInfo", error);
        });

      return Promise.resolve();
    };
  },

  getFooterInfo() {
    return (dispatch, getState) => {
      const {
        main: { footerInfo, socialLinks, preloaders }
      } = getState();

      if (footerInfo?.length || socialLinks?.length || preloaders.footerInfo) {
        return Promise.resolve();
      }

      dispatch(this.setLoading("footerInfo", true));
      apiClient
        .get("/members/api-v2/directory/get?command=links")
        .then(res => {
          dispatch({
            type: main.GET_FOOTER_INFO,
            payload: {
              footerInfo: res.data.data.footer_links,
              socialLinks: res.data.data.social_links
            }
          });
        })
        .catch(err => {
          dispatch({
            type: main.GET_FOOTER_INFO_FAIL,
            payload: err
          });
        });

      return Promise.resolve();
    };
  },

  setLoading(section, isSectionLoading) {
    return {
      type: main.SET_LOADING,
      payload: { section, isSectionLoading }
    };
  },

  getLoginStatus() {
    return dispatch => {
      apiClient("/members/json-api/login")
        .then(res => {
          dispatch({ type: main.GET_LOGIN, payload: res.data });
          dispatch({ type: auth.LOGIN_SUCCESS, payload: res.data });
        })
        .catch(error => {
          console.error("error", error.message);
          dispatch({ type: main.GET_LOGIN_FAIL, payload: false });
        });
    };
  },

  sendEmailCode(email) {
    return dispatch => {
      apiClient({
        method: "post",
        url: "members/api-v2/verification/email/send-code",
        data: { email },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(({ data }) => {
          dispatch({
            type: main.SEND_EMAIL_VERIFY_CODE_SUCCESS,
            payload: { token: data?.data?.token || "", email }
          });
        })
        .catch(() => dispatch({ type: main.SEND_EMAIL_VERIFY_CODE_FAIL }));
    };
  },

  checkEmailCode(code, setStatus) {
    return (dispatch, getState) => {
      dispatch(this.setLoading("verifyEmailCode", true));
      const { token, email } = getState().main.verifyEmailCode;
      apiClient({
        method: "post",
        url: "members/api-v2/verification/email/confirm-code",
        data: { code, token, email },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(() => {
          dispatch({ type: main.CHECK_EMAIL_VERIFY_CODE_SUCCESS });
          dispatch(profileActions.getProfile());
        })
        .catch(err => {
          setStatus({
            code: verificationConfirmErrorCopy(err, {
              wrongCode: i18n.t("dashboard_verify_code_wrong"),
              fallback: i18n.t("dashboard_common_error_generic")
            })
          });
          dispatch({ type: main.CHECK_EMAIL_VERIFY_CODE_FAIL });
        });
    };
  },

  logout() {
    return {
      type: auth.LOGOUT
    };
  },

  setViewNotification(ids) {
    return async dispatch => {
      // dispatch(this.setLoading("notifications", true));
      apiClient({
        method: "post",
        responseType: "json",
        url: "/members/json-api/notifications/view",
        data: JSON.stringify(ids),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      })
        .then(() => {
          dispatch({
            type: account.MARK_READ_NOTIFICATION,
            payload: ids
          });
        })
        .catch(() => {
          dispatch(this.setLoading("notifications", false));
        });
    };
  },

  setUnViewNotification(ids) {
    return dispatch => {
      apiClient({
        method: "post",
        responseType: "json",
        url: "/members/json-api/notifications/unview",
        data: JSON.stringify(ids),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      })
        .then(() => {
          dispatch({
            type: account.MARK_UN_READ_NOTIFICATION,
            payload: ids
          });
        })
        .catch(() => {
          dispatch(this.setLoading("notifications", false));
        });
    };
  },

  getCommunities() {
    return (dispatch, getState) => {
      const {
        main: { communities, preloaders }
      } = getState();

      if (communities?.length || preloaders.communities) {
        return Promise.resolve();
      }

      dispatch(this.setLoading("communities", true));
      apiClient({
        method: "get",
        responseType: "json",
        url: "/members/api-v2/communities?command=tree"
      })
        .then(res => {
          dispatch({
            type: main.GET_COMMUNITIES,
            payload: res.data.data
          });
        })
        .catch(error => {
          dispatch(this.setLoading("communities", false));
          console.error("getCommunities", error);
        });

      return Promise.resolve();
    };
  },

  setViewAllNotification() {
    return dispatch => {
      // dispatch(this.setLoading("notifications", true));

      apiClient({
        method: "post",
        responseType: "json",
        url: "/members/json-api/notifications/view-all",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      })
        .then(() => {
          dispatch({
            type: account.MARK_READ_ALL_NOTIFICATION
          });
        })
        .catch(() => {
          dispatch(this.setLoading("notifications", false));
        });
    };
  },

  togglePaymentError(isActive, errorMessage) {
    return {
      type: main.TOGGLE_PAYMENT_ERROR,
      payload: {
        isActive,
        errorMessage
      }
    };
  },

  toggleNewListing(isActive, listingType = "") {
    return {
      type: main.TOGGLE_NEW_LISTING,
      payload: {
        isActive,
        listingType
      }
    };
  },

  toggleMobileMenu(isActive) {
    return {
      type: main.TOGGLE_MOBILE_MENU,
      payload: {
        isActive
      }
    };
  }
};
